import script from "./CategoryFilterActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryFilterActivity.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryFilterActivity.vue?vue&type=style&index=0&id=012a5dc7&lang=scss"

const __exports__ = script;

export default __exports__